import PatientDataSummaryTitle from "./PatientDataSummaryTitle";
export default PatientDataSummaryTitle;
